import DeliveryNoteIcon from 'assets/dialogue-avatar-delivery-note.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { ArticleEvent, Milestone } from 'models/shipments';

import ViewAttemptedDeliveryCta from '../../common/ViewAttemptedDeliveryCta/ViewAttemptedDeliveryCta';

const attemptedDeliveryDefaultsBase = {
  analyticsId: 'attemptedDelivery',
  type: DialogueType.DELIVERY_NOTE,
  icon: <DeliveryNoteIcon />,
  customContent: undefined as React.ReactNode | JSX.Element | undefined,
};

const unknownCollectionPointCard = (eventReason: string) => ({
  ...attemptedDeliveryDefaultsBase,
  title: eventReason || 'We tried to deliver your parcel',
  content: (
    <>
      <p>We couldn’t deliver your parcel, so we’re taking it to a nearby Collection Point.</p>
      <p>We’ll let you know when and where to collect it.</p>
    </>
  ),
});

export function getAttemptedDeliveryCard(
  latestEvent: ArticleEvent | null,
  attemptedDeliveryPhotoAvailable: boolean
): DialogueCardData | null {
  if (attemptedDeliveryPhotoAvailable) {
    attemptedDeliveryDefaultsBase.customContent = <ViewAttemptedDeliveryCta />;
  } else {
    delete attemptedDeliveryDefaultsBase.customContent;
  }

  const { milestone, description: eventReason = '' } = latestEvent ?? {};
  if (milestone !== Milestone.ATTEMPTED_DELIVERY) return null;

  return unknownCollectionPointCard(eventReason);
}
